
import { useState, useEffect, useRef } from 'react';

const galleryItems = [
  {
    type: 'image',
    src: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/e28bd3b458526555c2540423f8e28cb4.jpeg',
    alt: 'Premium Şeffaf Plak 1'
  },
  {
    type: 'image',
    src: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/1c69a5586773b0f4e5c1572305196ed0.jpeg',
    alt: 'Premium Şeffaf Plak 2'
  },
  {
    type: 'image',
    src: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/53f51b78023501e1f47b389fd904b97a.jpeg',
    alt: 'Premium Şeffaf Plak 3'
  }
];

export default function GallerySection() {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const openModal = (index: number) => {
    setSelectedItem(index);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedItem(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      <section 
        ref={sectionRef}
        id="gallery" 
        className="py-20 section-padding bg-white"
      >
        <div className="container-max">
          <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-amber-600 to-yellow-500 bg-clip-text text-transparent">Premium Plaklarımız</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-yellow-500 mx-auto rounded-full"></div>
            <p className="text-xl text-gray-600 mt-6 max-w-2xl mx-auto">
              Yüksek kaliteli şeffaf plak tedavisi ürünlerimizi keşfedin
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {galleryItems.map((item, index) => (
              <div 
                key={index}
                className={`group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-700 cursor-pointer transform hover:-translate-y-2 ${
                  isVisible ? 'slide-up' : 'opacity-0'
                }`}
                style={{ animationDelay: `${index * 150}ms` }}
                onClick={() => openModal(index)}
              >
                <div className="relative h-80 overflow-hidden">
                  {item.type === 'image' ? (
                    <img 
                      src={item.src} 
                      alt={item.alt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  ) : (
                    <video 
                      src={item.src}
                      className="w-full h-full object-cover"
                      muted
                      loop
                      onMouseEnter={(e) => (e.target as HTMLVideoElement).play()}
                      onMouseLeave={(e) => (e.target as HTMLVideoElement).pause()}
                    />
                  )}
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="bg-white/20 backdrop-blur-sm rounded-full p-4">
                        <i className="ri-zoom-in-line text-3xl text-white"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* CTA Section */}
          <div className={`mt-16 text-center ${isVisible ? 'fade-in' : 'opacity-0'}`}>
            <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-8 border border-amber-200">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Size Özel Plak Tasarımı
              </h3>
              <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                Diş yapınıza özel olarak tasarlanan premium şeffaf plaklarımızla mükemmel gülüşe ulaşın
              </p>
              <button className="bg-gradient-to-r from-amber-600 to-yellow-500 text-white px-8 py-3 rounded-full font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300">
                Ücretsiz Konsültasyon
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedItem !== null && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white hover:text-amber-400 transition-colors"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            
            {galleryItems[selectedItem].type === 'image' ? (
              <img 
                src={galleryItems[selectedItem].src}
                alt={galleryItems[selectedItem].alt}
                className="max-w-full max-h-full object-contain rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <video 
                src={galleryItems[selectedItem].src}
                controls
                autoPlay
                className="max-w-full max-h-full rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
